import React, { useRef } from "react";
import { Modal, Button, Form, Tabs, Tab, TabContent } from "react-bootstrap";
import { useState, useEffect } from "react";
import {
  ModalBodyBlack,
  ModalFooterBlack,
  ModalHeaderBlack,
  MyModal,
} from "../../features/RadConnStyle";
import axios from "axios";
import { HttpJsonHeader } from "../../features/Environments";
import {
  formatDateTimeYYYYMMDDHHMMSS,
  FormatThaiCard,
  XButton,
} from "../../core/Helper";
import { useDispatch } from "react-redux";
import { setReminder } from "../../features/UserActions";
import styled from "styled-components";

import ConfirmDialogB from "../components/ConfirmDialogB";
import { useReactToPrint } from "react-to-print";
import { pdf, PDFViewer, StyleSheet } from "@react-pdf/renderer";
import DocumentBuilder from "../radi/DocumentBuilder";
import { saveAs } from "file-saver";

function StudyShowResult(props) {
  const { userDetail, showStudyResult, setShowStudyResult, selectedRow } =
    props;
  const dispatch = useDispatch();
  const [dataX, setDataX] = useState(null);
  const [updateFlag, setUpdateFlag] = props.updateFlag;
  const [confirm, setConfirm] = useState({ show: false, action: () => {} });
  const [repcheck, setRepCheck] = useState(1);
  const [fullScreen, setFullScreen] = useState(false);
  const [printFrm, setPrintFrm] = useState({ show: false, action: () => {} });

  const refForm1 = useRef(null);
  //const uploadType = {FILE:1, CAPTURED:2};
  const editorContentRef = useRef(null); //Reference of RichTextEditor's editor
  const editRef = useRef(null); // Referrence of RichTextEditor

  const [docu, setDocu] = useState();
  const [loading, setLoading] = props.loading;

  const [resText, setResText] = useState("");

  //----------------------------------------------------------------------
  useEffect(() => {
    if (showStudyResult.action != null) {
      getInfo(() => {
        showStudyResult.action();
      });
    }
    return () => {
      setDataX(null);
    };
  }, [showStudyResult?.show]);

  // Effect ข้อมูลผลอ่านและแสดงบนชุดรายงาน
  useEffect(() => {
    if (dataX && dataX.studyResult.length > 0) {
      setDocu(<DocumentBuilder data={dataX} setLoading={setLoading} />);

      let radResu = "";
      radResu = `ชื่อ-นามสกุล: ${dataX?.studyInfo?.patients_name} \r\n`;
      radResu += `HN: ${dataX?.studyInfo?.patientid} \r\n`;
      radResu += `เพศ: ${
        dataX?.studyInfo?.patients_sex
          ?.replace(/[Mm]/g, "ชาย")
          .replace(/[Ff]/g, "หญิง") ?? "-"
      } \r\n`;
      radResu += `อายุ: ${dataX?.studyInfo?.patients_age
        ?.replace(/^0+/g, "")
        ?.replace(/[y,Y]/g, " ปี")
        ?.replace(/[m,M]/, " เดือน")} \r\n`;

      radResu += `ส่วนที่ตรวจ: ${dataX?.priceItems?.map((item, index) => {
        return index > 0
          ? (", " + item?.goodname ?? "")
          : (item?.goodname ?? "");
      })}\r\n`;
      radResu += `--------------------------------------------------------------------------------- \r\n`;
      radResu += dataX?.studyResult[0]?.result_text;
      setResText(radResu);
    }
  }, [dataX]);

  /*  แสดงข้อมูลคนไข้  */
  const getInfo = (callback) => {
    if (props.selectedRow == null) return;
    axios
      .post(
        process.env.REACT_APP_API + "api/studyinfo/getStudyInfoWithHistory",
        {
          StudyInfo: { ...props.selectedRow },
          UserInfo: userDetail,
        },
        HttpJsonHeader,
      )
      .then((response) => {
        // console.log("ALL RESULT", response.data);
        if (response.data) {
          let tmp = response.data;
          setDataX({
            studyInfo: {
              ...tmp.StudyInfo[0],
              patients_idcard:
                tmp &&
                tmp.StudyInfo[0]?.patients_idcard &&
                FormatThaiCard(response.data.StudyInfo[0]?.patients_idcard),
            },
            attachedFile: tmp.StudyFileAttached,
            priceItems: tmp.PriceItems,
            studyResult: tmp.StudyResults,
            studyHistory: tmp.StudyHistory,
          });
          // ประเภทของการบันทึกผล
          setRepCheck(
            tmp.StudyResults && tmp.StudyResults.length > 0
              ? tmp.StudyResults[0].result_type_id
              : 1,
          );
          callback();
        }
      })
      .catch((err) =>
        dispatch(
          setReminder({ show: true, message: err.message, type: "error" }),
        ),
      );
  };

  // Print document
  const printResult = useReactToPrint({
    content: () => editorContentRef.current,
  });

  /*** -------------------------------------------------- */

  return (
    <MyModal
      show={showStudyResult.show}
      // size="xl"
      onHide={() => setShowStudyResult({ show: false })}
      backdrop={false}
      centered
      fullscreen={true}
    >
      <ModalHeaderBlack closeButton>
        ผลอ่านแพทย์{props.formName}
        <div
          style={{
            flex: "1",
            display: "flex",
            padding: "0px 5px 0px 0px",
            justifyContent: "right",
          }}
        ></div>
      </ModalHeaderBlack>

      <ModalBodyBlack
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "0px",
        }}
      >
        {/* <img
          style={{ width: "150px", height: "150px" }}
          src={"./logos/logo_branch_" + dataX?.studyInfo.brchid + ".png"}
          alt=""
        /> */}
        {/* <div style={{ display: "flex" }}>
          <ALabelTitle
            style={{ maxWidth: "90px", backgroundColor: "transparent" }}
          >
            ชือ-สกุล
          </ALabelTitle>
          <ALabelInfo style={{ flex: "1" }}>
            {dataX && dataX.studyInfo.patients_name}
          </ALabelInfo>
          <ALabelTitle style={{ maxWidth: "50px" }}>เพศ</ALabelTitle>
          <ALabelInfo style={{ flex: "1", maxWidth: "60px" }}>
            {dataX && dataX.studyInfo.patients_sex == "M" ? "ชาย" : "หญิง"}
          </ALabelInfo>
          <ALabelTitle style={{ maxWidth: "50px" }}>อายุ</ALabelTitle>
          <ALabelInfo style={{ flex: "1", maxWidth: "80px" }}>
            {dataX &&
              dataX.studyInfo.patients_age
                .replace(/^0+/g, "")
                .replace(/[y,Y]/g, " ปี")
                .replace(/[m,M]/, " เดือน")}
          </ALabelInfo>
          <ALabelTitle style={{ maxWidth: "50px" }}>HN</ALabelTitle>
          <ALabelInfo style={{ flex: "1", maxWidth: "120px" }}>
            {dataX && dataX.studyInfo.patientid}
          </ALabelInfo>
        </div> */}

        {/* แสดงผลอ่าน */}

        <ATabs defaultActiveKey="pdf">
          {/* PDF Result */}
          <ATab eventKey="pdf" title="PDF">
            <TabContent style={contentWrapper}>
              <XButton
                style={{ maxWidth: "100px" }}
                onClick={() => {
                  pdf(docu)
                    .toBlob()
                    .then((bb) =>
                      saveAs(
                        bb,
                        `${formatDateTimeYYYYMMDDHHMMSS(new Date())}$${
                          dataX?.studyInfo?.patientid
                        }$${dataX?.studyInfo?.accession_number}`,
                      ),
                    );
                }}
              >
                Export
              </XButton>
              <PDFViewer style={styles.container} children={docu}></PDFViewer>
            </TabContent>
          </ATab>

          {/* TEXT Result */}

          <ATab eventKey="text" title="Text">
            <TabContent style={contentWrapper}>
              <Form.Control
                style={textEditor}
                as="textarea"
                defaultValue={
                  // "HN:" +
                  //   "\r\n" +
                  // dataX?.studyResult[0]?.result_text
                  resText
                }
                rows={20}
              />
            </TabContent>
          </ATab>
        </ATabs>
      </ModalBodyBlack>

      <ModalFooterBlack style={{ flex: "0.1" }}>
        <Form id="fromCheck" ref={refForm1} style={formStyle1}>
          <div style={{ flex: "1", display: "flex", padding: "2px" }}>
            <div
              style={{ display: "flex", flex: "3", padding: "2px 0 0 0px" }}
            ></div>

            <div>
              {/* <Button style={{ margin: "2px" }} variant="info">
                <FcDecision style={{ height: "30px", width: "30px" }} />
                แจ้งปัญหา
              </Button>*/}
              <button
                class="clear-btn"
                onClick={() => setShowStudyResult({ show: false })}
              >
                ปิด
              </button>
            </div>
          </div>
        </Form>
      </ModalFooterBlack>
      <ConfirmDialogB {...{ winState: [confirm, setConfirm] }} />
      {/* <PrintDocu {... {winState:[printFrm, setPrintFrm], ...editRef}} /> */}
    </MyModal>
  );
}

const Styles = {
  accordionBody: { background: "#222222", padding: "0 0 0 0px" },
  buttonTemplate: { marginRight: "5px" },
  buttonImage: {
    marginRight: "5px",
    color: "yellow",
    height: "30px",
    width: "30px",
  },
  buttonImageBig: {
    marginRight: "5px",
    color: "yellow",
    height: "40px",
    width: "40px",
  },

  innerIconButton: { marginTop: "-5px" },
};

const styles = StyleSheet.create({
  container: {
    border: "1px solid transparent",
    flex: "1",
    display: "block",
    width: "80%",
    minHeight: "80vh",
    marginHorizontal: 0,
    marginVertical: 0,
    padding: 0,
    backgroundColor: "white",
    borderRadius: "10px",
    marginLeft: "auto",
    marginRight: "auto",
  },
});

const textEditor = {
  border: "1px solid transparent",
  flex: "1",
  display: "block",
  width: "80%",
  minHeight: "80vh",
  marginHorizontal: 0,
  marginVertical: 0,
  padding: 0,
  backgroundColor: "white",
  borderRadius: "10px",
  marginLeft: "auto",
  marginRight: "auto",
};

const contentWrapper = {
  fontFamily: "Times New Roman",
  minHeight: "70vh",
  // maxWidth: "1000px",
  marginLeft: "auto",
  marginRight: "auto",
  paddingBlock: "10px",
  backgroundColor: "var(--tab-active-background)",

  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
};

export default React.memo(StudyShowResult);

const formStyle1 = {
  flex: "1",
  display: "flex",
  padding: "0 0 0 0px",
  margin: "0 0 0 0px",
  borderRadius: "0px",
  flexDirection: "column",
};

//* หัว tab
const ATabs = styled(Tabs)`
  /* background-color: #121212; */
  /* display: flex; */
  /* flex: 1; */
  justify-content: start;
  /* border: 1px solid black; */
`;

const ATab = styled(Tab)`
  /* background-color: #121212; */

  /* padding: 0;
  display: flex;
  flex: 1;
  justify-content: start;
  min-height: 90vh; */
  padding-inline: 50px;
`;
